import ComingSoon from '../../components/ComingSoon/ComingSoon'
import Seo from '../../components/Seo'

const PulauSemporna = () => {
    return (
        <>
            <Seo
                title="Bohey Dulang Floating Resort | Semporna, Sabah | ALG"
                description="Discover the upcoming Bohey Dulang ALG Floating Resort in Semporna, Sabah. Enquire with ALG Hotel Resort & Tour for updates."
                path="/pulau-semporna"
                image="/Semporna.jpg"
            />
            <ComingSoon
                title="SELAKAN"
                subtitle="Semporna"
                bgImage="/Semporna.jpg"
            />
        </>
    )
}

export default PulauSemporna
